window.addEventListener('alpine:init', bootstrap);
export default () => ({
	open: false,
	depth: 0,
	height: 'auto',
	base_height: null,
	headingClick(e) {
		if ( this.base_height === null ) {
			this.base_height = this.$refs.container.offsetHeight;
		}
		/* eslint-disable */
		const $container = e.target.parentNode.parentNode;
		/* eslint-enable */
		const $sub_menu = e.target.parentNode.querySelector('.sub-menu');
		if ( $sub_menu === null ) { return; }
		this.depth = this.depth + 1;
		$sub_menu.classList.add('is-active');

		const menu_height = $sub_menu.offsetHeight;
		if ( menu_height > this.base_height ) {
			this.height = menu_height + 'px';
		} else {
			this.height = 'auto';
		}
	},
	lsClick(e) {
		const $sub_menu = e.target.parentNode.querySelector('.wpml-ls');
		if ( $sub_menu === null ) { return; }

		this.depth = this.depth + 1;
		$sub_menu.classList.add('is-active');
	},
	backClick(e) {
		window.setTimeout(
			() => { e.target.parentNode.parentNode.classList.remove('is-active'); },
			500
		);
		this.depth = this.depth - 1;
		this.height = 'auto';

	},
	get depth_class() {
		return `has-depth-${this.depth}`;
	}
});

function bootstrap() {
	const $els = document.querySelectorAll('[x-data="mobileMenu"]');
	$els.forEach( $el => bootstrapEl($el) );
}

function bootstrapEl($el) {
	const $menu = $el.querySelector('ul.mobile-menu');
	$menu.setAttribute(':class', 'depth_class');
	$menu.querySelectorAll('h3').forEach( $h3 => {
		const $sub_menu = $h3.parentNode.querySelector('.sub-menu');
		if ( $sub_menu === null ) { return; }

		const $back_item = $h3.cloneNode(true);
		const $ancestor_back_el = $h3.parentNode.parentNode.firstChild.firstChild;
		if ( $ancestor_back_el.classList.contains('is-backlink') ) {
			const text = $ancestor_back_el.textContent + ' / ' + $h3.textContent;
			$back_item.textContent = text;
		}
		$back_item.setAttribute('x-on:click', 'backClick');
		$back_item.classList.add('is-backlink');

		const $li = document.createElement('li');
		$li.appendChild($back_item);
		$sub_menu.insertBefore($li, $sub_menu.firstChild);
	});

	$menu.querySelectorAll('.ls-trigger').forEach( $ls => {
		const $sub_menu = $ls.parentNode.querySelector('.wpml-ls');
		if ( $sub_menu === null ) { return; }

		const lang_label = $ls.dataset.langLabel;
		const $back_item = document.createElement('h3');
		$back_item.setAttribute('x-on:click', 'backClick');
		$back_item.classList.add('is-backlink');
		$back_item.textContent = lang_label;

		const $li = document.createElement('li');
		$li.appendChild($back_item);
		$sub_menu.insertBefore($li, $sub_menu.firstChild);
	});
}

